module.exports = __webpack_public_path__ + "static/media/react.ebfb3a10.svg";